<script setup lang="ts">
import { useField } from 'vee-validate'

const originalProps = defineProps<{
  name: string
  disabled?: boolean
  default?: boolean
  value?: string
  label?: string
  description?: string
  block?: boolean
  disableStoryblok?: boolean
  title?: string
  tooltip?: any
  hideErrors?: boolean
}>()
const emit = defineEmits(['checked'])

const ga4 = useAnalytics()

const props = originalProps.disableStoryblok ? originalProps : useStoryblokProps(originalProps)
const { value: inputValue, handleChange, errorMessage } = useField<boolean | string[]>(props.name, {}, {
  type: 'checkbox',
})

if (props.default && !inputValue) handleChange(props.value || true)

const isChecked = computed(() => {
  return isArray(inputValue.value) ? inputValue.value?.includes(props.value) : inputValue.value
})
function click() {
  if (props.disabled) return
  handleChange(props.value || !inputValue.value)
  emit('checked', isChecked.value)
  ga4.trackEvent({ event_action: 'checkbox', event_label: originalProps?.name })
}
</script>

<template>
  <div>
    <BaseLabel v-if="props.title">
      {{ props.title }}
    </BaseLabel>
    <div
      class="flex group select-none cursor-pointer gap-2.5" @click="click"
    >
      <div
        :class="{ 'bg-primary border-primary': isChecked, 'bg-white': !isChecked, 'bg-gray border-gray group-hover:border-gray': disabled }"
        class="border min-w-6 min-h-6 max-h-6 rounded-lg flex items-center text-white justify-center group-hover:border-hover transition-colors duration-300"
      >
        <input v-model="inputValue" :data-test-id="`FieldCheckBox|${name}${value ? '|' : ''}${value || ''}`" :value="props.value" :name="props.name" type="checkbox" hidden>
        <AppIcon v-show="isChecked" size="12" icon="far-check" class="" />
      </div>
      <slot>
        <div>
          <div class="flex items-center gap-2.5 mb-5px">
            <label class="cursor-pointer" :for="props.name">{{ props.label }}</label>
            <BaseTooltip v-if="props.tooltip?.length" v-bind="props.tooltip?.[0]" />
          </div>
          <div v-if="props?.description" class="text-gray-dark">
            {{ props.description }}
          </div>
        </div>
      </slot>
    </div>
    <FormFieldErrorMessage v-if="errorMessage && !props.hideErrors">
      {{ errorMessage }}
    </FormFieldErrorMessage>
  </div>
</template>
